<template>
  <div class="table-records">
    <span> Showing {{ first }} - {{ second }} of {{ total }} records </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps(["pages", "perPage", "total"]);

const first = computed(() => {
  let calculateFirst = (props.pages - 1) * props.perPage + 1;
  if (calculateFirst > props.total) return props.total;
  return calculateFirst;
});
const second = computed(() => {
  let calculateSecond = props.pages * props.perPage;
  if (calculateSecond > props.total) return props.total;
  return calculateSecond;
});
</script>

<style scoped>
.table-records {
  background-color: #f4f5f8;
  padding: 2px;
  text-align: center;
}
</style>
